import { connect } from 'react-redux';

import { loadPointsThisWeek } from '../../actions/dashboardActions';
import {
  getLoadPointsThisWeekWaiting,
  getPointsThisWeek,
  getRank,
  getStats,
} from '../../components/Dashboard/dashboardSelectors';
import MyStats from '../../components/Dashboard/MyStats/myStats.jsx';
import { getLoading, getUser } from '../../components/User/userSelectors';

const mapStateToProps = (state, ownProps) => ({
  statsData: getStats(state),
  pointsThisWeek: getPointsThisWeek(state),
  rank: getRank(state),
  loginStreak: getUser(state).loginStreak,
  longestLoginStreak: getUser(state).longestLoginStreak,
  pointsThisWeekWaiting: getLoadPointsThisWeekWaiting(state),
  loginStreakWaiting: getLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadPointsThisWeek: () => dispatch(loadPointsThisWeek()),
});

const MyStatsContainer = connect(mapStateToProps, mapDispatchToProps)(MyStats);

export default MyStatsContainer;
